function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "21",
  viewBox: "0 0 16 21",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M6.992 0C3.139 0 .005 3.183.005 7.097c0 0-.445 5.376 6.987 12.903 6.225-6.323 6.923-11.118 6.987-12.495 0-.129.021-.28.021-.408C13.979 3.16 10.845 0 6.992 0z",
  id: "path-pin"
})), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "map/Abschnitt/Planung",
  transform: "translate(-26 -332)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ort",
  transform: "translate(27 327)"
}, /*#__PURE__*/React.createElement("g", {
  id: "planung-Pin",
  transform: "translate(0 6)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-pin",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-pin"
})), /*#__PURE__*/React.createElement("use", {
  id: "Shape",
  stroke: "#353535",
  fillRule: "nonzero",
  xlinkHref: "#path-pin"
})))))));